import { ValidationService } from '@vk-hr-tek/core/validation';
import { useInject } from '@vk-hr-tek/core/ioc';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { Link } from '@vk-hr-tek/ui/Link';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { useDispatch, useSelector } from '@app/hooks';

import { ChangePasswordInitDto } from '../../../dto';
import {
  selectNotification,
  selectStatus,
  changePasswordInit,
  redirectToSendInviteForPhone,
  redirectToLogin,
} from '../../../slice';
import { Button } from '../../../segments';
import { useGetAuthInstance } from '../../../hooks';

export const ChangePasswordInit = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);

  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const authInstance = useGetAuthInstance();

  const { button_color: buttonColor } = authInstance;

  const onSubmit = (values: ChangePasswordInitDto) =>
    new Promise((resolve) => {
      dispatch(
        changePasswordInit({
          values,
          actions: { resolve },
        }),
      );
    });

  const handleRedirectToLogin = () => dispatch(redirectToLogin());

  const handleRedirectToSendInviteForPhone = () =>
    dispatch(redirectToSendInviteForPhone());

  return (
    <Form
      validate={(values) => validator.validate(values, ChangePasswordInitDto)}
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        submitting,
        pristine,
        hasValidationErrors,
        dirtySinceLastSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <TextInput
            name="snils"
            label="СНИЛС"
            placeholder="Введите свой СНИЛС"
            mask="999-999-999 99"
            id="qaAuthChangePasswordInitSnilsInput"
            testId="test-id-snils-input"
          />
          <Box mt="8">
            <TextInput
              name="phone"
              label="Номер телефона"
              placeholder="+7"
              mask="+7 (999) 999-99-99"
              id="qaAuthChangePasswordInitPhoneInput"
              testId="test-id-phone-input"
            />
          </Box>
          <Box mt="32">
            <Button
              color={buttonColor && `#${buttonColor}`}
              disabled={pristine || hasValidationErrors}
              loading={submitting}
              testId="test-id-init-submit-button"
            >
              Продолжить
            </Button>
          </Box>
          {!dirtySinceLastSubmit && status && status === 'failed' && (
            <FormError error={error} />
          )}
          <Box
            mt="8"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Link
              onClick={handleRedirectToLogin}
              size="small"
              variant="tertiary"
              startIcon={<Icon name="chevron_left" size="16" />}
            >
              Вернуться назад
            </Link>
            <Link
              onClick={handleRedirectToSendInviteForPhone}
              size="small"
              variant="tertiary"
            >
              Я сменил телефон
            </Link>
          </Box>
        </form>
      )}
    />
  );
};
